import type { Model } from '@patsnap/tahiti-core/common/model';
import type { QueryHighlight } from '../types';

export const QueryHighlightModel = Symbol.for('QueryHighlightModel');

export interface QueryHighlightModel extends Model<QueryHighlight> {}
